import styles from './hint.module.scss';

interface IHint {
	children?: React.ReactNode;
}
export const Hint = (props: IHint) => {
	return <div className={styles.wrapper}>{props.children}</div>;
};
